import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import {
  FaTimes, FaPaw, FaUser, FaCalendarAlt, FaCheck,
  FaChevronDown,    
} from "react-icons/fa";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import OrderNumberBadge from "./OrderNumberBadge";
import LoaderSpiner from "../LoaderSpiner/LoaderSpiner";
import { httpService } from "../../services/httpService";
import StaffSelector from "../../pages/Orders/StaffSelector";
import { useProfile } from "../../context/ProfileContext";
import OrderFormsSection from "./OrderFormsSection";

import PaymentDrawer from "../Order/PaymentDrawer";
import OrderPaymentDrawer from "../../components/Order/OrderPaymentDrawer";
// ─── time helpers ────────────────────────────────────────────────────────────

function parseTimeRange(timeRange) {
  if (!timeRange) return null;
  try {
    for (const sep of ["–", "-", "to", "TO"]) {
      if (timeRange.includes(sep)) {
        const parts = timeRange.split(sep).map((p) => p.trim());
        if (parts.length >= 2) return { startTime: parts[0], endTime: parts[1] };
      }
    }
    return { startTime: timeRange.trim(), endTime: "" };
  } catch { return null; }
}

function parseTimeToDate(timeStr) {
  if (!timeStr) return null;
  try {
    const c = timeStr.trim().toUpperCase();
    const t = new Date(`2000-01-01 ${c}`);
    if (!isNaN(t.getTime())) return t;
    const m = c.match(/(\d+):?(\d*)\s*(AM|PM)?/i);
    if (m) {
      let h = parseInt(m[1], 10);
      const min = m[2] ? parseInt(m[2], 10) : 0;
      const mer = (m[3] || "").toUpperCase();
      if (mer === "PM" && h < 12) h += 12;
      if (mer === "AM" && h === 12) h = 0;
      return new Date(2000, 0, 1, h, min);
    }
    return null;
  } catch { return null; }
}

function generateTimeSlotsFromRange(startTime, endTime, interval = 15) {
  const slots = [];
  const start = parseTimeToDate(startTime);
  const end   = parseTimeToDate(endTime);
  if (!start || !end) return generateDefaultTimeSlots();
  let cur = new Date(start);
  while (cur <= end) {
    slots.push(cur.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true }));
    cur = new Date(cur.getTime() + interval * 60 * 1000);
  }
  return slots;
}

function generateDefaultTimeSlots() {
  const slots = [];
  for (let s = 8 * 60; s <= 20 * 60; s += 15) {
    slots.push(new Date(0, 0, 0, Math.floor(s / 60), s % 60)
      .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true }));
  }
  return slots;
}

 const normalizeToSlotFormat = (t) => {
  if (!t) return "";
  const cleaned = t.trim();
  // Try parsing as-is first (handles "9:00 AM", "9:00 am", "14:30", "9:00 am - 10:00 am")
  // If it contains a range separator, take only the start
  const withoutRange = cleaned.split(/\s*[–\-]\s*/)[0].trim();
  const parsed = new Date(`2000-01-01 ${withoutRange}`);
  if (!isNaN(parsed.getTime())) {
    return parsed.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  }
  // Fallback: manual parse for "HH:MM" 24h
  const m = withoutRange.match(/^(\d{1,2}):(\d{2})$/);
  if (m) {
    const date = new Date(2000, 0, 1, parseInt(m[1], 10), parseInt(m[2], 10));
    return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
  }
  return cleaned;
}

//  function resolveTimeAndSlots(startTime, timeRange) {
//   const hasStartTime = startTime && startTime.trim() !== "";

//   if (hasStartTime) {
//     const trFromStart = parseTimeRange(startTime); // handles case where start_time is itself a range
//     if (trFromStart?.startTime && trFromStart?.endTime) {
//       return {
//         selected: normalizeToSlotFormat(trFromStart.startTime),
//         slots: generateTimeSlotsFromRange(trFromStart.startTime, trFromStart.endTime),
//       };
//     }
//     return { selected: normalizeToSlotFormat(startTime), slots: generateDefaultTimeSlots() };
//   }

//   const tr = parseTimeRange(timeRange || "");
//   if (tr?.startTime && tr?.endTime) {
//     return {
//      // selected: normalizeToSlotFormat(tr.startTime),
//       slots: generateTimeSlotsFromRange(tr.startTime, tr.endTime),
//     };
//   }

//   return { selected: "", slots: generateDefaultTimeSlots() };
// }

// ─── Build time slots restricted to business hours for a given date ───────────
// function buildBusinessHourSlots(dateStr, bh) {
//   if (!bh || !dateStr) return null;

//   const parseTime = (timeStr) => {
//     if (!timeStr) return 0;
//     const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
//     if (!match) return 0;
//     let h = parseInt(match[1]);
//     const m = parseInt(match[2]);
//     const meridiem = match[3].toUpperCase();
//     if (meridiem === "PM" && h !== 12) h += 12;
//     if (meridiem === "AM" && h === 12) h = 0;
//     return h * 60 + m;
//   };

//   // 1. Check special day
//   const specialDay = bh.specialDays?.find(
//     (sd) => sd.date?.split("T")[0] === dateStr
//   );

//   let sourceSlots = [];
//   if (specialDay) {
//     if (!specialDay.isOpen) return [];
//     sourceSlots = specialDay.slots || [];
//   } else {
//     // 2. Weekly schedule
//     const [yr, mo, dy] = dateStr.split("-").map(Number);
//     const dayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
//     const dayName  = dayNames[new Date(yr, mo - 1, dy).getDay()];
//     const weekDay  = bh.weeklySchedule?.find((d) => d.day === dayName);
//     if (!weekDay?.isOpen) return [];        // day closed → empty list
//     sourceSlots = bh.timeSlots || [];
//     if (!sourceSlots.length) return null;  // no slot config → caller uses fallback
//   }

//   // 3. Generate 15-min slots within each window
//   const slots = [];
//   sourceSlots.forEach(({ start: s, end: e }) => {
//     const startMin = parseTime(s);
//     const endMin   = parseTime(e);
//     let cur = startMin;
//     while (cur < endMin) {
//       slots.push(
//         new Date(0, 0, 0, Math.floor(cur / 60), cur % 60)
//           .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true })
//       );
//       cur += 15;
//     }
//   });
//   return slots.length ? slots : null;
// }
  function buildBusinessHourSlots(dateStr, bh) {
    if (!bh || !dateStr) return null;

    const parseTime = (timeStr) => {
      if (!timeStr) return 0;
      const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
      if (!match) return 0;
      let h = parseInt(match[1]);
      const m = parseInt(match[2]);
      const meridiem = match[3].toUpperCase();
      if (meridiem === "PM" && h !== 12) h += 12;
      if (meridiem === "AM" && h === 12) h = 0;
      return h * 60 + m;
    };

    const dayNames = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
    const [yr, mo, dy] = dateStr.split("-").map(Number);
    const dayName = dayNames[new Date(yr, mo - 1, dy).getDay()];
    const weekDay = bh.weeklySchedule?.find((d) => d.day === dayName);

    const specialDay = bh.specialDays?.find(
      (sd) => sd.date?.split("T")[0] === dateStr
    );

    let sourceSlots = [];
    let blockedSlots = [];
    let noConfig = false;

    if (specialDay) {
      if (specialDay.label === "Closed") return [];
      if (specialDay.label === "Full Day") {
        sourceSlots = bh.timeSlots || [];
      } else if (specialDay.label === "Custom Hours") {
        if (specialDay.isOpen) {
          // isOpen:true → the listed slots ARE the open windows for the day
          sourceSlots = specialDay.slots || [];
        } else {
          // isOpen:false → the listed slots are a BLOCKED window inside a
          // normal working day — NOT the whole day being closed
          if (!weekDay?.isOpen) return [];
          sourceSlots = bh.timeSlots || [];
          blockedSlots = specialDay.slots || [];
        }
      }
    } else {
      if (!weekDay?.isOpen) return [];
      sourceSlots = bh.timeSlots || [];
      if (!sourceSlots.length) noConfig = true;
    }

    if (noConfig) return null; // caller falls back to booking's own start_time/range

    const isBlocked = (mins) =>
      blockedSlots.some(({ start, end }) => mins >= parseTime(start) && mins < parseTime(end));

    const slots = [];
    sourceSlots.forEach(({ start: s, end: e }) => {
      const startMin = parseTime(s);
      const endMin   = parseTime(e);
      let cur = startMin;
      while (cur < endMin) {
        if (!isBlocked(cur)) {
          slots.push(
            new Date(0, 0, 0, Math.floor(cur / 60), cur % 60)
              .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true })
          );
        }
        cur += 15;
      }
    });
    return slots;
  }


function resolveTimeAndSlots(startTime, timeRange, dateStr, bh) {
  const bhSlots = buildBusinessHourSlots(dateStr, bh);
  // null  → no BH config, fall through to booking range or default
  // []    → day closed
  // [...] → use these

  const hasStartTime = startTime && startTime.trim() !== "";

  if (hasStartTime) {
    const trFromStart = parseTimeRange(startTime);
    if (trFromStart?.startTime && trFromStart?.endTime) {
      const rangeSlots = generateTimeSlotsFromRange(trFromStart.startTime, trFromStart.endTime);
      return {
        selected: normalizeToSlotFormat(trFromStart.startTime),
        slots: bhSlots ?? rangeSlots,
      };
    }
    return {
      selected: normalizeToSlotFormat(startTime),
      slots: bhSlots ?? generateDefaultTimeSlots(),
    };
  }

  const tr = parseTimeRange(timeRange || "");
  if (tr?.startTime && tr?.endTime) {
    const rangeSlots = generateTimeSlotsFromRange(tr.startTime, tr.endTime);
    return { slots: bhSlots ?? rangeSlots };
  }

  return { selected: "", slots: bhSlots ?? generateDefaultTimeSlots() };
}


function formatDisplayDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
}

function formatDateForInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`;
}

function getFormattedDuration(item) {
  const dur = item?.duration;
  if (!dur) return "";
  if (typeof dur === "string" && dur.toLowerCase().includes("minute")) return dur;
  if (item.item_type === "boarding")   return `${dur} Day${Number(dur) > 1 ? "s" : ""}`;
  if (item.item_type === "vet_clinic") return `${dur} Minutes`;
  return dur;
}

 function isPastDate(item) {
  if (!item?.start_date) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const itemDate = new Date(item.start_date);
  itemDate.setHours(0, 0, 0, 0);
  return itemDate < today;
}

// ─── rabies vaccination check  ──────────────────────────
const normalizeVaccinationEntries = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === "string") return item.trim();
        if (item && typeof item === "object") {
          return (
            item.vaccine ||
            item.vaccination ||
            item.name ||
            item.label ||
            ""
          )
            .toString()
            .trim();
        }
        return "";
      })
      .filter(Boolean);
  }
  if (typeof value === "string") {
    return value
      .split(/[,;|]+/)
      .map((item) => item.trim())
      .filter(Boolean);
  }
  if (typeof value === "object") {
    return Object.values(value)
      .map((item) => item?.toString?.().trim?.() || "")
      .filter(Boolean);
  }
  return [];
};
const hasRabiesVaccination = (pet) => {
  const vaccinationList = normalizeVaccinationEntries(pet?.vaccinations || pet?.vaccinated_for);
  const recordList = normalizeVaccinationEntries(pet?.vaccination_records);
  const statusText = (
    pet?.vaccination_status ||
    pet?.vaccinationStatus ||
    pet?.pet_vaccination_status ||
    ""
  ).toLowerCase();
  const rabiesRegex = /rabies/i;
  const allVaccines = [...vaccinationList, ...recordList];
  return allVaccines.some((v) => rabiesRegex.test(v)) || rabiesRegex.test(statusText);
};

// ─── Status badge ─────────────────────────────────────────────────────────────

function StatusBadge({ status, isQueue, isPast }) {
    if (isPast) {
    return (
      <span style={{ display:"inline-flex", alignItems:"center", padding:"2px 9px",
        borderRadius:20, fontSize:11, fontWeight:700, letterSpacing:"0.03em",
        background:"#f3f4f6", color:"#6b7280", border:"1px solid #d1d5db", whiteSpace:"nowrap" }}>
        Past Date
      </span>
    );
  }
  const effectiveLabel = isQueue === 1 ? "booked" : status;
  const map = {
    confirmed: { label: "Scheduled", bg: "#ecfdf5", color: "#065f46", border: "#6ee7b7" },
    booked:    { label: " Queue ",  bg: "#eff6ff", color: "#1d4ed8", border: "#bfdbfe" },
    cancelled: { label: "Cancelled", bg: "#fef2f2", color: "#991b1b", border: "#fca5a5" },
  };
  const s = map[effectiveLabel];
  if (!s) return null;
  return (
    <span style={{ display:"inline-flex", alignItems:"center", padding:"2px 9px",
      borderRadius:20, fontSize:11, fontWeight:700, letterSpacing:"0.03em",
      background:s.bg, color:s.color, border:`1px solid ${s.border}`, whiteSpace:"nowrap" }}>
      {s.label}
    </span>
  );
}


// ─── Checkbox ────────────────────────────────────────────────────────────────

function ItemCheckbox({ isQueue, checked, onChange, mode = "queue", isPast }) {
  const locked = isPast || ( mode === "scheduled"
    ? isQueue === 1        
    : isQueue !== 1);      
  if (locked) {
    return (
      <div title={isPast ? "Past date — cannot be scheduled" : undefined}
      style={{ width:20, height:20, borderRadius:4, border:"1.5px solid #d1d5db",
        background:"#f3f4f6", display:"flex", alignItems:"center", justifyContent:"center",
        flexShrink:0, cursor:"not-allowed" }}>
        <FaTimes size={10} color="#9ca3af" />
      </div>
    );
  }
  return (
    <div onClick={onChange} style={{ width:20, height:20, borderRadius:4,
      border:`1.5px solid ${checked?"#16a34a":"#d1d5db"}`,
      background:checked?"#16a34a":"#fff", display:"flex", alignItems:"center",
      justifyContent:"center", flexShrink:0, cursor:"pointer", transition:"all 0.15s" }}>
      {checked && <FaCheck size={10} color="#fff" />}
    </div>
  );
}

// ─── Notes row ───────────────────────────────────────────────────────────────
function NotesRow({ notes }) {
  const [expanded, setExpanded] = useState(false);
  const truncate = (t) => t.length > 70 ? t.slice(0, 70) + "…" : t;
  return (
    <div className="flex items-start gap-2 mb-3">
      <svg
        className="w-4 h-4 text-gray-500 mt-0.5 flex-shrink-0"
        fill="none" stroke="currentColor" viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
      <div className="text-sm text-gray-700 flex-1">
        <span className="font-semibold">Notes:</span>{" "}
        {expanded ? notes : truncate(notes)}
        {notes.length > 70 && (
          <button
            onClick={() => setExpanded(e => !e)}
            className="ml-2 text-blue-600 hover:text-blue-800 font-medium text-xs focus:outline-none">
            {expanded ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    </div>
  );
}

// ─── Service section ─────────────────────────────────────────────────────────

const ServiceSection = ({ title, headerMeta, statusBadge, checkboxEl, isLocked, children, initialOpen = true }) => {
  //const [open, setOpen] = useState(true);
  const [open, setOpen] = useState(initialOpen);
  return (
    <div style={{ border:"1px solid #e5e7eb", borderRadius:10, overflow:"hidden",
      marginBottom:10, opacity:isLocked ? 0.72 : 1, transition:"opacity 0.2s" }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between",
        padding:"10px 14px", background:isLocked?"#f9fafb":"#fff",
        borderBottom:open?"1px solid #e5e7eb":"none", userSelect:"none" }}>
        <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap", flex:1, minWidth:0 }}>
          {checkboxEl}
          <span style={{ fontWeight:700, fontSize:14, color:isLocked?"#6b7280":"#111827" }}>{title}</span>
          {headerMeta}
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:8, flexShrink:0 }}>
          {statusBadge}
          <div onClick={() => setOpen(o=>!o)} style={{ cursor:"pointer", display:"flex", alignItems:"center" }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af"
              strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
              style={{ transform:open?"rotate(0deg)":"rotate(180deg)", transition:"transform 0.2s" }}>
              <polyline points="18 15 12 9 6 15" />
            </svg>
          </div>
        </div>
      </div>
      {open && (
        <div style={{ padding:"12px 14px", background:isLocked?"#fafafa":"#fff" }}>
          {children}
        </div>
      )}
    </div>
  );
};

// ─── Actions dropdown ─────────────────────────────────────────────────────────

function ActionsDropdown({ onSave, onCancel, onModify, onUnschedule, onPayNow, disabled, isSaving }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const items = [
    onSave   && { label: isSaving ? "Saving…" : "Save",         action: onSave,   color: "#2563eb" },
    onModify && { label: "Modify Order",  action: onModify, color: "#374151" },
    onCancel && { label: "Cancel Order",  action: onCancel, color: "#dc2626" },
    onUnschedule  && { label: "Unschedule", action: onUnschedule,  color: "#d97706" },
    onPayNow     && { label: "Pay Now",       action: onPayNow, color: "#16a34a" },
  ].filter(Boolean);

  return (
    <div ref={ref} style={{ position:"relative" }}>
      <button
        onClick={() => !disabled && setOpen(o=>!o)}
        disabled={disabled}
        style={{
          padding:"10px 18px", borderRadius:10, border:"1.5px solid #d1d5db",
          cursor:disabled?"not-allowed":"pointer", background:"#fff", color:"#374151",
          fontWeight:700, fontSize:14, display:"flex", alignItems:"center", gap:7,
          opacity:disabled?0.6:1,
        }}>
        Actions <FaChevronDown size={11} />
      </button>
      {open && (
        <div style={{
          position:"absolute", bottom:"calc(100% + 6px)", left:0, background:"#fff",
          border:"1px solid #e5e7eb", borderRadius:10, boxShadow:"0 8px 24px rgba(0,0,0,0.12)",
          zIndex:200, minWidth:160, overflow:"hidden",
        }}>
          {items.map(item => (
            <button
              key={item.label}
              onClick={() => { setOpen(false); item.action(); }}
              style={{
                display:"block", width:"100%", padding:"10px 16px", background:"none",
                border:"none", textAlign:"left", cursor:"pointer", fontSize:13.5,
                fontWeight:600, color:item.color,
              }}
              onMouseEnter={e => e.currentTarget.style.background = item.color==="#dc2626"?"#fef2f2":"#f9fafb"}
              onMouseLeave={e => e.currentTarget.style.background = "none"}>
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── small style helpers ──────────────────────────────────────────────────────

const fieldLabel = (txt) => (
  <div style={{ fontSize:12, color:"#111827", fontWeight:700, textTransform:"uppercase",
    letterSpacing:"0.05em", marginBottom:5 }}>{txt}</div>
);

const readOnlyBox = (val) => (
  <div style={{ border:"1px solid #e5e7eb", borderRadius:8, padding:"8px 12px",
    fontSize:13.5, color:"#374151", background:"#f9fafb", fontWeight:500,
    minHeight:38 }}>
    {val || "—"}
  </div>
);

const fieldError = (msg) => msg ? (
  <div style={{ fontSize:11, color:"#dc2626", marginTop:4, fontWeight:500 }}>
    {msg}
  </div>
) : null;

const dropdownStyle = (hasVal, disabled) => ({
  width:"100%", border:"1px solid #d1d5db", borderRadius:8, padding:"8px 12px",
  fontSize:13.5, color:hasVal?"#111827":"#9ca3af",
  background:disabled?"#f9fafb":"#fff", outline:"none",
  cursor:disabled?"not-allowed":"pointer",
});

// ─── Main component ───────────────────────────────────────────────────────────

const BookingOrderPopup = ({
  isOpen,
  orderId,
   highlightRefId,
  onClose, 
  onSchedule, 
  onModify, 
  onViewOrder, 
  refreshData,
  employees = [],
  isEmployee,
  loggedInEmployeeId,
  mode = "queue",       // "queue" | "scheduled"
  onCheckIn,            // called when Check In clicked (scheduled mode)
  onScheduleSuccess,    // called after successful schedule (optional)
}) => {
  const ref = useRef(null);
  const highlightRefIdRef = useRef(highlightRefId);
  useEffect(() => { highlightRefIdRef.current = highlightRefId; }, [highlightRefId]);

    const { profileData } = useProfile();

  const getVaccinationSetting = () =>
    profileData?.systemSettings?.vaccination_requirement ||
    profileData?.vaccination_requirement ||
    null;

  const normalizeServiceName = (value) =>
    String(value || "").trim().toLowerCase();

  const serviceMatches = (settingName, currentServiceName) => {
    const setting = normalizeServiceName(settingName);
    const current = normalizeServiceName(currentServiceName);
    if (!setting || !current) return false;
    return (
      setting === current ||
      setting.includes(current) ||
      current.includes(setting)
    );
  };

  const isVaccinationRequiredForService = (item, defaultType = "") => {
    const vaccineSetting = getVaccinationSetting();
    if (!vaccineSetting) return false;
    const isEnabled =
      vaccineSetting.enabled === true ||
      vaccineSetting.enabled === "true" ||
      vaccineSetting.enabled === 1 ||
      vaccineSetting === true;
    if (!isEnabled) return false;

    if (
      !Array.isArray(vaccineSetting.services) ||
      vaccineSetting.services.length === 0
    ) {
      return true;
    }
    const candidates = [
      item?.service_type_name,
      item?.service_category_name,
      item?.category_name,
      item?.service_name,
      item?.item_type,
      defaultType,
    ].filter(Boolean);

    return candidates.some((candidate) =>
      vaccineSetting.services.some((s) => {
        const name = s?.name || s?.type || s;
        return serviceMatches(name, candidate);
      })
    );
  };

  const [loading,        setLoading]        = useState(false);
  const [processedOrder, setProcessedOrder] = useState(null);
  const [checkedItems,   setCheckedItems]   = useState({});
  const [isSaving,       setIsSaving]       = useState(false);
  const [isCancelling,    setIsCancelling]    = useState(false);
  const [isScheduling, setIsScheduling] = useState(false);
  const [isCheckingIn,    setIsCheckingIn]    = useState(false);
  const [isUnscheduling,  setIsUnscheduling]  = useState(false);
  // ── Boarding per-item room state (keyed by item index) ───────────────────
  // roomTypesData[idx]  = array of room-type objects from API
  // roomsData[idx]      = array of room-number objects for the selected type
  const [roomTypesData,      setRoomTypesData]      = useState({});
  const [roomsData,          setRoomsData]          = useState({});
  const [selectedRoomTypeId, setSelectedRoomTypeId] = useState({});
  const [selectedRoomId,     setSelectedRoomId]     = useState({});
  const [fetchingRooms,      setFetchingRooms]      = useState({});
  const [roomMsg,            setRoomMsg]            = useState({});
  // track original values so we can highlight changes
  const origRoomTypeRef = useRef({});
  const origRoomIdRef   = useRef({});

  // ── Grooming/Vet per-item appointment state ───────────────────────────────
  // apptDetail[idx] = live data from /vendorappointment/getVendorAppointment
  const [apptDetail,     setApptDetail]     = useState({});
  const [fetchingAppt,   setFetchingAppt]   = useState({});
  const [selectedStaff,  setSelectedStaff]  = useState({});
  const [selectedTime,   setSelectedTime]   = useState({});
  const [timeSlots,      setTimeSlots]      = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [itemBusinessHours, setItemBusinessHours] = useState({});

  // ── Per-item mandatory form status (from OrderFormsSection) ───────────────
  const [pendingMandatoryMap, setPendingMandatoryMap] = useState({});
  const [itemFormIdsMap, setItemFormIdsMap] = useState({});
  const [formBypassMap, setFormBypassMap] = useState({});

  const getItemKey = (item) =>
    String(item?.ref_id || item?.id || item?._id || item?.item_id || "");

  const handleMandatoryStatusChange = (itemKey, hasPendingMandatory) => {
    if (!itemKey) return;
    setPendingMandatoryMap((prev) => ({ ...prev, [itemKey]: hasPendingMandatory }));
  };

  const handleFormIdsChange = (itemKey, formIds) => {
    if (!itemKey) return;
    setItemFormIdsMap((prev) => ({ ...prev, [itemKey]: formIds }));
  };

  const handleFormBypassChange = (itemKey, bypassed) => {
    if (!itemKey) return;
    setFormBypassMap((prev) => ({ ...prev, [itemKey]: bypassed }));
  };

  const [showPaymentDrawer, setShowPaymentDrawer] = useState(false);

  // ── Forms Submitted state ─────────────────────────────────────────────────
  const [formStatuses,  setFormStatuses]  = useState([]);
  const [loadingForms,  setLoadingForms]  = useState(false);
  const [updatingForm,  setUpdatingForm]  = useState(false);

  const selectedIdx = processedOrder?.order_items?.findIndex((_, i) => checkedItems[i]) ?? -1;
  const selectedItem = selectedIdx >= 0 ? processedOrder.order_items[selectedIdx] : null;

  const hasPendingMandatoryForSelected = React.useMemo(() => {
    if (!selectedItem) return false;
    const itemKey = getItemKey(selectedItem);
    return !!pendingMandatoryMap[itemKey] && !formBypassMap[itemKey];
  }, [selectedItem, pendingMandatoryMap, formBypassMap]);
  // ─────────────────────────────────────────────────────────────────────────
  const fetchRoomsForItem = async (item, idx) => {
  if (!item.start_date || !item.end_date || !item.pet_type) return;
  setFetchingRooms(p => ({ ...p, [idx]: true }));
  setRoomMsg(p => ({ ...p, [idx]: "Checking availability…" }));
  try {
    const res = await httpService.post("/room/getAvailableVendorRooms", {
      checkIn:             formatDateForInput(item.start_date),
      checkOut:            formatDateForInput(item.end_date),
      type:                "boarding",
      petType:             item.pet_type || "Dog",
      excludingBoardingId: item.ref_id,
    });

    const roomTypes = res.data;

    if (!roomTypes || !roomTypes.length) {
      setRoomsData(p => ({ ...p, [idx]: [] }));
      setRoomMsg(p => ({ ...p, [idx]: `No rooms available for ${item.pet_type}.` }));
      return;
    }

    // ── KEY CHANGE: don't store all roomTypes, just find the matching one ──
    // item.room_type_id is already known from order data — find its rooms
    const matchingType = roomTypes.find(rt => rt._id === item.room_type_id);
     // || roomTypes[0]; // fallback to first if original type not in response
     
     if (!matchingType) {
      setRoomsData(p => ({ ...p, [idx]: [] }));
      setRoomMsg(p => ({ ...p, [idx]: `No rooms available in "${item.room_name || "assigned"}" room type for ${item.pet_type}.` }));
      return;
    }

    const rooms = (matchingType?.room_numbers || []).filter(r => r.is_available !== false);

    setRoomMsg(p => ({ ...p, [idx]: rooms.length ? "" : "No rooms available for this room type." }));
    setRoomsData(p => ({ ...p, [idx]: rooms }));

    // pre-select original room if still available
    const origRoomId = item.room_id || null;
    origRoomIdRef.current[idx] = origRoomId;
    const roomToSelect = (origRoomId && rooms.some(r => r._id === origRoomId))
      ? origRoomId : "";
    setSelectedRoomId(p => ({ ...p, [idx]: roomToSelect }));

    // selectedRoomTypeId stays as item.room_type_id — set it for the save payload
    origRoomTypeRef.current[idx] = item.room_type_id || null;
    setSelectedRoomTypeId(p => ({ ...p, [idx]: item.room_type_id || null }));

  } catch (err) {
    console.error("fetchRoomsForItem:", err);
    setRoomMsg(p => ({ ...p, [idx]: "Error loading rooms" }));
    setRoomsData(p => ({ ...p, [idx]: [] }));
  } finally {
    setFetchingRooms(p => ({ ...p, [idx]: false }));
  }
};

  // Extract available room-number objects from a room-type object.
  // API may return available_room_numbers (pre-filtered) or room_numbers (full list).
  const getRoomsFromType = (typeObj) => {
    if (!typeObj) return [];
    if (Array.isArray(typeObj.available_room_numbers) && typeObj.available_room_numbers.length)
      return typeObj.available_room_numbers;
    return (typeObj.room_numbers || []).filter(r => r.is_available !== false);
  };

  // Called when user changes the room-type dropdown
  const onRoomTypeChange = (idx, typeId) => {
    setSelectedRoomTypeId(p => ({ ...p, [idx]: typeId }));
    setSelectedRoomId(p => ({ ...p, [idx]: "" }));
    const chosen = (roomTypesData[idx] || []).find(rt => rt._id === typeId);
    setRoomsData(p => ({ ...p, [idx]: getRoomsFromType(chosen) }));
  };

  // REPLACE WITH:
const fetchBusinessHoursForItem = async (item, idx) => {
    try {
      let endpoint = "";
      if (item.item_type === "grooming")   endpoint = "/groominghours/getgroomingbusinesshours";
      if (item.item_type === "vet_clinic") endpoint = "/vethours/getvetbusinesshours";
      if (!endpoint) return null;

      const res = await httpService.get(endpoint);
      const data = res.data?.data || res.data || null;
      if (!data) return null;

      setItemBusinessHours(p => ({ ...p, [idx]: data }));
      return data;   // ← return it
    } catch (err) {
      console.warn("fetchBusinessHoursForItem failed for idx", idx, err);
      return null;
    }
  };

 // Re-seed time slots whenever per-item BH data arrives
    useEffect(() => {
      if (!processedOrder?.order_items) return;
      processedOrder.order_items.forEach((item, idx) => {
        const bh = itemBusinessHours[idx];
        if (!bh) return;
        const dateStr = item.start_date?.split("T")[0] || "";
        const { selected, slots } = resolveTimeAndSlots(
          item.start_time,
          item.time_range,
          dateStr,
          bh,
        );
        setTimeSlots(p => ({ ...p, [idx]: slots }));
        setSelectedTime(p => ({
          ...p,
          [idx]: p[idx] || selected,  // keep user's pick if already chosen
        }));
      });
    }, [itemBusinessHours]); // eslint-disable-line react-hooks/exhaustive-deps
  // ─────────────────────────────────────────────────────────────────────────
  // Fetch live appointment data for one grooming/vet item
  // (pattern from AppointmentConfirmTooltip)
  // ─────────────────────────────────────────────────────────────────────────
  const fetchApptForItem = async (item, idx, bh = null) => {
    if (!item.ref_id) return;
    setFetchingAppt(p => ({ ...p, [idx]: true }));
    try {
      const res = await httpService.get(`/vendorappointment/getVendorAppointment/${item.ref_id}`);
      const data = res.data?.data || res.data || null;
      if (!data) return;
      setApptDetail(p => ({ ...p, [idx]: data }));

      // staff
      const techId = data.technician_id || data.employee_id || "";
      setSelectedStaff(p => ({ ...p, [idx]: techId }));

      // time
      // let initTime = "";
      // if (data.start_time && !data.start_time.includes("–")) {
      //   initTime = data.start_time;
      // } else if (data.time_range) {
      //   const tr = parseTimeRange(data.time_range);
      //   if (tr?.startTime) initTime = tr.startTime;
      // }
      // //setSelectedTime(p => ({ ...p, [idx]: initTime }));
      // // time slots: if online order use the booking window; else full day
      // let slots = generateDefaultTimeSlots();
      // const tr = parseTimeRange(item.start_time || "");
      // if (tr?.startTime && tr?.endTime)
      //   slots = generateTimeSlotsFromRange(tr.startTime, tr.endTime);
      // setTimeSlots(p => ({ ...p, [idx]: slots }));
      // setSelectedTime(p => ({ ...p, [idx]: normalizeToSlotFormat(initTime) }));
     const { selected, slots } = resolveTimeAndSlots(
      data.start_time || item.start_time,
      data.time_range || item.time_range,
      item.start_date?.split("T")[0] || "",
      bh ?? itemBusinessHours[idx] ?? null
    );
    setTimeSlots(p => ({ ...p, [idx]: slots }));
    setSelectedTime(p => ({ ...p, [idx]: selected }));
    
    } catch (err) {
      // non-fatal: fall back to order-level start_time
      console.warn("fetchApptForItem fallback for idx", idx, err);
      // still build time slots from order item start_time
      // const tr = parseTimeRange(item.start_time || "");
      // let slots = generateDefaultTimeSlots();
      // if (tr?.startTime && tr?.endTime)
      //   slots = generateTimeSlotsFromRange(tr.startTime, tr.endTime);
      // setTimeSlots(p => ({ ...p, [idx]: slots }));
      const { selected, slots } = resolveTimeAndSlots(item.start_time, 
        item.time_range,
        item.start_date?.split("T")[0] || "",
        bh ?? itemBusinessHours[idx] ?? null
      );
      setTimeSlots(p => ({ ...p, [idx]: slots }));
      setSelectedTime(p => ({ ...p, [idx]: selected }));

      // pre-fill staff from order item if available
      if (item.technician_id)
        setSelectedStaff(p => ({ ...p, [idx]: item.technician_id }));
    } finally {
      setFetchingAppt(p => ({ ...p, [idx]: false }));
    }
  };
  // ─────────────────────────────────────────────────────────────────────────
  // Fetch the order, then kick off per-item fetches
  // ─────────────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!isOpen || !orderId) return;

    // reset everything
    setProcessedOrder(null);
    setCheckedItems({});
    setRoomTypesData({}); setRoomsData({});
    setSelectedRoomTypeId({}); setSelectedRoomId({});
    setFetchingRooms({}); setRoomMsg({});
    setApptDetail({}); setFetchingAppt({});
    setSelectedStaff({}); setSelectedTime({}); setTimeSlots({});
    setItemBusinessHours({});
    setPendingMandatoryMap({});
    setItemFormIdsMap({});
    origRoomTypeRef.current = {}; origRoomIdRef.current = {};

    const load = async () => {
      setLoading(true);
      try {
        const res       = await httpService.get(`/vendororder/getvendororder/${orderId}`);
        const orderData = res.data?.data || res.data;
        const visibleOrderItems =
          isEmployee && loggedInEmployeeId
            ? (orderData.order_items || []).filter((item) => {
                const itemType = (
                  item.item_type ||
                  item.type ||
                  ""
                ).toLowerCase();

                // Always show boarding services
                if (itemType === "boarding") return true;

                return (
                  item.technician_id === loggedInEmployeeId ||
                  item.employee_id === loggedInEmployeeId
                );
              })
            : orderData.order_items || [];
        const items = visibleOrderItems
  .map(item => ({
          ...item,
          displayStartDate: formatDisplayDate(item.start_date),
          displayEndDate:   item.end_date ? formatDisplayDate(item.end_date) : null,
          order_id: orderData?._id,
        }))
        .sort((a, b) => {
          const priority = (item) =>
            mode === "scheduled"
              ? (item.is_queue !== 1 ? 0 : 1)
              : (item.is_queue === 1 ? 0 : 1);
          return priority(a) - priority(b);
        });
        setProcessedOrder({
          ...orderData, order_items: items,
          displayClientName:  `${orderData.client_first_name||""} ${orderData.client_last_name||""}`.trim(),
          displayClientPhone: orderData.client_phone,
          displayClientEmail: orderData.client_email,
        });

        const initChecked = {};
        items.forEach((item, idx) => {
          const itemRef = String(item.ref_id || item._id || item.id || "");
          const targetRef = String(highlightRefIdRef.current || "");
          initChecked[idx] = !!(targetRef && itemRef === targetRef);
          if (item.item_type === "boarding") {
    // if (item.status === "booked") {
    //   // needs scheduling — fetch available rooms from API
    //   fetchRoomsForItem(item, idx);
    // } else {
    //   // already confirmed — seed display values directly from order data, no API call
    //   origRoomTypeRef.current[idx] = item.room_type_id || null;
    //   origRoomIdRef.current[idx]   = item.room_id || null;
    //   setSelectedRoomTypeId(p => ({ ...p, [idx]: item.room_type_id || null }));
    //   setSelectedRoomId(p => ({ ...p, [idx]: item.room_id || null }));
    //   // seed roomsData with just the one known room so readOnlyBox resolves
    //   if (item.room_id && item.room_number) {
    //     setRoomsData(p => ({
    //       ...p,
    //       [idx]: [{ _id: item.room_id, room_number: item.room_number }],
    //     }));
    //   }
    //   // seed roomTypesData with just the known type so currentRoomTypeName resolves
    //   if (item.room_type_id && item.room_name) {
    //     setRoomTypesData(p => ({
    //       ...p,
    //       [idx]: [{ _id: item.room_type_id, room_name: item.room_name }],
    //     }));
    //   }
    // }
  //   const needsLiveRooms =
  // item.status === "booked" ||
  // (mode === "scheduled" && item.status === "confirmed");
  const needsLiveRooms =
  item.is_queue === 1 ||
  (mode === "scheduled" && item.is_queue !== 1);

  if (needsLiveRooms) {
  fetchRoomsForItem(item, idx);
} else {
  // seed static display values — unchanged
  origRoomTypeRef.current[idx] = item.room_type_id || null;
  origRoomIdRef.current[idx]   = item.room_id || null;
  setSelectedRoomTypeId(p => ({ ...p, [idx]: item.room_type_id || null }));
  setSelectedRoomId(p => ({ ...p, [idx]: item.room_id || null }));
  if (item.room_id && item.room_number) {
    setRoomsData(p => ({
      ...p,
      [idx]: [{ _id: item.room_id, room_number: item.room_number }],
    }));
  }
  if (item.room_type_id && item.room_name) {
    setRoomTypesData(p => ({
      ...p,
      [idx]: [{ _id: item.room_type_id, room_name: item.room_name }],
    }));
  }
}
  }else if (item.item_type === "grooming" || item.item_type === "vet_clinic") {
  // Seed time immediately from order item data — no need to wait for appointment API
  // if (item.start_time) {
  //   const normalizedTime = normalizeToSlotFormat(item.start_time);
  //   // Build slots first, then set the selected value into them
  //   const tr = parseTimeRange(item.start_time || "");
  //   let slots = generateDefaultTimeSlots();
  //   // For online orders the start_time might be a range like "9:00 AM – 10:00 AM"
  //   if (tr?.startTime && tr?.endTime) {
  //     slots = generateTimeSlotsFromRange(tr.startTime, tr.endTime);
  //   }
  //   setTimeSlots(p => ({ ...p, [idx]: slots }));
  //   setSelectedTime(p => ({ ...p, [idx]: normalizedTime }));
  // }
     const { selected, slots } = resolveTimeAndSlots(item.start_time, 
      item.time_range,
      item.start_date?.split("T")[0] || "",
      null
    );
      setTimeSlots(p => ({ ...p, [idx]: slots }));
      setSelectedTime(p => ({ ...p, [idx]: selected }));
     // fetchApptForItem(item, idx);
      //fetchBusinessHoursForItem(item, idx);
      fetchBusinessHoursForItem(item, idx).then((bh) =>
     fetchApptForItem(item, idx,bh)
    );
    }
    });

        if (!Object.values(initChecked).some(Boolean) && items.length > 0) {
          initChecked[0] = true;
        }
        setCheckedItems(initChecked);
      } catch (err) {
        console.error("load order error:", err);
        toast.error("Failed to load order details");
      } finally { setLoading(false); }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, orderId]);

  // ─────────────────────────────────────────────────────────────────────────
  // Handlers
  // ─────────────────────────────────────────────────────────────────────────

  const toggleChecked = (idx) => setCheckedItems(p => ({ ...p, [idx]: !p[idx] }));

  const getCheckedBookedItems = () =>
    (processedOrder?.order_items || []).filter((_, idx) => checkedItems[idx]);

  // AFTER
const handleCancel = async () => {
    const result = await Swal.fire({
      title: "Cancel Order?",
      text: "This will cancel the entire order. Continue?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Cancel All",
    });
    if (!result.isConfirmed) return;

    setIsCancelling(true);
    try {
      const cancelOrderId =
        processedOrder?.order_id || processedOrder?._id || orderId;

      if (!cancelOrderId) {
        toast.error("Order ID is missing. Unable to cancel order.");
        return;
      }
      await httpService.post("/vendororder/cancelOrder", {
        order_id: cancelOrderId,
      });

      toast.success("Order cancelled successfully.");
      await refreshData?.();
      setTimeout(() => {
        onClose();
      }, 1200);
    } catch (err) {
      console.error("Error cancelling order:", err);
      toast.error(err?.response?.data?.message || "Failed to cancel order.");
    } finally {
      setIsCancelling(false);
    }
  };
 // ── Save: persist field changes without requiring all fields or changing status ──
const handleSave = async () => {
  const anyChecked = processedOrder?.order_items?.some((_, i) => checkedItems[i]);
  if (!anyChecked) { toast.warn("No items selected."); return; }

  setIsSaving(true);
  try {
    for (let i = 0; i < processedOrder.order_items.length; i++) {
      if (!checkedItems[i]) continue;
      const item = processedOrder.order_items[i];
      if (item.item_type === "boarding") {
        if (selectedRoomId[i]) {
          await httpService.post("/vendorbooking/updateVendorBookingRoom", {
            roomTypeId:        selectedRoomTypeId[i],
            roomId:            selectedRoomId[i],
            ref_id:            item.ref_id,
            keepOriginalPrice: true,
           // save: true
          });
        }
      } else {
        if (selectedStaff[i] || selectedTime[i]) {
          await httpService.post("/vendorappointment/updateVendorAppointmentStaff", {
            staffId:   selectedStaff[i] || "",
            time_slot: selectedTime[i] || "",
            ref_id:    item.ref_id,
            save: true
          });
        }
      }
    }
    toast.success("Changes saved!");
    refreshData?.();
    setTimeout(onClose, 1500);
  } catch {
    toast.error("Failed to save changes.");
  } finally { setIsSaving(false); }
};

const isScheduleDisabled = () => {
  const checkedList =
    processedOrder?.order_items?.filter((_, i) => checkedItems[i]) || [];

  if (!checkedList.length) {
    return true;
  }

  return processedOrder.order_items.some((item, i) => {
    if (!checkedItems[i]) return false;

    if (item.item_type === "boarding") {
      return !selectedRoomId[i];
    }

    return !selectedStaff[i] || !selectedTime[i];
  });
};

// ── Schedule: validate required fields then confirm, exactly like BookingConfirmTooltip ──
const handleSchedule = async () => {
  const checkedList = processedOrder?.order_items?.filter((_, i) => checkedItems[i]) || [];
  if (!checkedList.length) { toast.warn("Select at least one item to schedule."); return; }

  // Build inline field errors first
  const errors = {};
  let hasError = false;

  for (let i = 0; i < processedOrder.order_items.length; i++) {
    if (!checkedItems[i]) continue;
    const item = processedOrder.order_items[i];
    //   if (isPastDate(item)) {
    //   toast.error(`Past date booking! cannot be scheduled.`);
    //   return;
    // }
    if (item.item_type === "boarding") {
      if (!selectedRoomId[i]) {
        errors[`room_${i}`] = "Select a room number to schedule this booking.";
        hasError = true;
      }
    } else {
      if (!selectedStaff[i]) {
        errors[`staff_${i}`] = "Select staff to schedule this booking.";
        hasError = true;
      }
      if (!selectedTime[i]) {
        errors[`time_${i}`] = "Select a time to schedule this booking.";
        hasError = true;
      }
    }
  }

  if (hasError) {
    setFieldErrors(errors);
    toast.error("Some bookings couldn't be scheduled. Please fill in the required fields.");
    return;
  }

  setFieldErrors({});
  setIsScheduling(true);
  try {
    for (let i = 0; i < processedOrder.order_items.length; i++) {
      if (!checkedItems[i]) continue;
      const item = processedOrder.order_items[i];
      const formIds =
        itemFormIdsMap[getItemKey(item)] ||
        (Array.isArray(item.form_ids) ? item.form_ids : []);

      if (item.item_type === "boarding") {
        await httpService.post("/vendorbooking/updateVendorBookingRoom", {
          roomTypeId:        selectedRoomTypeId[i],
          roomId:            selectedRoomId[i],
          ref_id:            item.ref_id,
          keepOriginalPrice: true,
          is_queue : 0 ,
          ...(formIds.length > 0 && { form_ids: formIds }),
        });
      } else {
        await httpService.post("/vendorappointment/updateVendorAppointmentStaff", {
          staffId:   selectedStaff[i],
          time_slot: selectedTime[i],
          ref_id:    item.ref_id,
          is_queue : 0 ,
          ...(formIds.length > 0 && { form_ids: formIds }),
        });
      }
    }
    toast.success("Scheduled successfully!");

    const scheduledIdx = processedOrder.order_items.findIndex(
      (it, i) => checkedItems[i] && it.item_type !== "boarding" && selectedTime[i]
    );
    if (scheduledIdx >= 0) {
      window.dispatchEvent(
        new CustomEvent("scheduler:scroll-to-time", {
          detail: { time: selectedTime[scheduledIdx] },
        })
      );
    }

    refreshData?.();
    const scheduledOrderId = processedOrder?.order_id || processedOrder?._id;
    if (onScheduleSuccess && scheduledOrderId) {
      onScheduleSuccess(scheduledOrderId);
      onClose();
    } else {
      setTimeout(onClose, 1500);
    }
  } catch {
    toast.error("Failed to schedule. Please try again.");
  } finally { setIsScheduling(false); }
};
  const handleModifyAction = () => {
  const target = getCheckedBookedItems()[0]
    || processedOrder?.order_items?.find(it => it.ref_id === highlightRefId)
    || processedOrder?.order_items?.find(it =>
    mode === "scheduled" ? it.is_queue !== 1 : it.is_queue === 1
   );
  if (target && onModify) { onClose(); onModify(target); }
};

 const handlePayNow = () => {
  const target = getCheckedBookedItems()[0]
    || processedOrder?.order_items?.find(it => it.ref_id === highlightRefId)
    || processedOrder?.order_items?.find(it =>
        mode === "scheduled" ? it.is_queue !== 1 : it.is_queue === 1
      );

  if (!target) {
    toast.warn("Select an item to pay for.");
    return;
  }

  setShowPaymentDrawer(true);
};

  const handleUnschedule = async () => {
    const checkedList = processedOrder?.order_items?.filter((_, i) => checkedItems[i]) || [];
    if (!checkedList.length) { toast.warn("Select at least one item to unschedule."); return; }

    const result = await Swal.fire({
      title: "Unschedule?",
      text: "This will remove the room/staff assignment and move the booking back to queue.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d97706",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Yes, unschedule",
    });
    if (!result.isConfirmed) return;

    setIsUnscheduling(true);
    try {
      for (let i = 0; i < processedOrder.order_items.length; i++) {
        if (!checkedItems[i]) continue;
        const item = processedOrder.order_items[i];

        if (item.item_type === "boarding") {
          // ✅ Same API as drag-from-calendar-to-queue
          await httpService.post("/vendorbooking/moveVendorBookingToQueue", {
            booking_id: item.ref_id,
            is_queue: 1,
          });
        } else {
          // grooming / vet — clear staff & time, revert to booked
          await httpService.post("/vendorappointment/updateVendorAppointmentStaff", {
            staffId:    "",
            time_slot:  "",
            ref_id:     item.ref_id,
            unschedule: true,
            is_queue:1,
          });
        }
      }
      toast.success("Booking moved back to queue.");
      refreshData?.();
      setTimeout(onClose, 1500);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to unschedule.");
    } finally {
      setIsUnscheduling(false);
    }
  };

  const handleCheckIn = () => {
    const idx = processedOrder.order_items.findIndex((_, i) => checkedItems[i]);
    if (idx === -1) { toast.warn("Select an item to check in."); return; }
    const item = processedOrder.order_items[idx];

    // ✅ Build the same shape that normalizeBookingData expects in CalendarGrid
    const checkInPayload = {
      ...item,
      ref_id:            item.ref_id,
      order_id:          processedOrder.order_id || processedOrder._id,
      order_number:      processedOrder.order_number,
      vendor_client_id:  processedOrder.vendor_client_id,
      vendor_pet_id:     item.vendor_pet_id,
      startDate:         item.start_date,
      endDate:           item.end_date,
      room_type_id:      selectedRoomTypeId[idx] || item.room_type_id,
      room_id:           selectedRoomId[idx]     || item.room_id,
      room_name:         item.room_name,
      room_number:       item.room_number,
      // Fields normalizeBookingData needs for the ServiceInitiationDrawer
      client_first_name: processedOrder.client_first_name ||
                        processedOrder.displayClientName?.split(" ")[0] || "",
      client_last_name:  processedOrder.client_last_name  ||
                        processedOrder.displayClientName?.split(" ").slice(1).join(" ") || "",
      phone:             processedOrder.displayClientPhone || "",
      service_type_name: item.service_type_name ||
        (item.item_type === "boarding" ? "Kennel Boarding"
         : item.item_type === "grooming" ? "Grooming Salon"
         : item.item_type === "vet_clinic" ? "Vet Clinic"
         : ""),
      service_name:      item.service_name || "",
      pet_type:          item.pet_type || "",
      pet_name:          item.pet_name || "",
      pet_breed:         item.pet_breed || "",
      pet_size:          item.pet_size || "",
      status:            item.status,
    };

    onClose("checkin");
    onCheckIn?.(checkInPayload);
  };
  // outside click
  useEffect(() => {
    const h = (e) => {
      if (e.target.closest(".swal2-container") || e.target.closest(".swal2-popup") ||
          e.target.closest(".reschedule-drawer-wrapper")) return;
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    if (isOpen) document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [isOpen, onClose]);

  // ─────────────────────────────────────────────────────────────────────────
  // Render
  // ─────────────────────────────────────────────────────────────────────────

  if (!isOpen) return null;
  // Queue bars are position:fixed at z-index 50, and the month/date
  // headers are sticky around z-index 40. Those layers sit above this
  // popup when it renders inside the calendar, so the backdrop never
  // blocks them. Portaling to document.body puts the popup above both.
  const popupZ = 200;
  if (loading || !processedOrder) {
    return createPortal(
      <div className="fixed inset-0 flex items-center justify-center bg-black/20 backdrop-blur-sm" style={{ zIndex: popupZ }}>
        <LoaderSpiner text="Loading…" />
      </div>,
      document.body
    );
  }
  return createPortal(
    <>
      <div className="fixed inset-0 bg-black/50" style={{ zIndex: popupZ }} onClick={onClose} />

      <div ref={ref} className="fixed bg-white flex flex-col overflow-hidden"
        style={{ left:"50%", top:"50%", transform:"translate(-50%,-50%)",
          width:660, maxWidth:"96vw", maxHeight:"90vh",
          borderRadius:14, boxShadow:"0 20px 60px rgba(0,0,0,0.18)",
          fontFamily:"'Inter','Segoe UI',system-ui,sans-serif",
          zIndex: popupZ + 1 }}>

        {/* HEADER */}
        <div style={{ padding:"14px 18px", borderBottom:"1px solid #f3f4f6",
          display:"flex", alignItems:"center", justifyContent:"space-between",
          background:"#fff", flexShrink:0 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <OrderNumberBadge orderNumber={processedOrder.order_number}
              orderType={processedOrder.order_type||"offline"}
              className="text-sm px-4 py-2 rounded-lg font-bold shadow-sm border border-black flex items-center" />
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              <div style={{ width:32, height:32, borderRadius:"50%", background:"#f3f4f6",
                display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                <FaUser size={14} color="#9ca3af" />
              </div>
              <div>
                <div style={{ fontWeight:700, fontSize:15, color:"#111827",
                  display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" }}>
                  <span>{processedOrder.displayClientName}</span>
                  {processedOrder.displayClientPhone && (
                    <span style={{ fontWeight:500, color:"#6b7280", fontSize:13 }}>
                      ({processedOrder.displayClientPhone})
                    </span>
                  )}
                </div>
                {processedOrder.displayClientEmail && (
                  <div style={{ fontSize:12, color:"#9ca3af", marginTop:1 }}>
                    {processedOrder.displayClientEmail}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ border:"1.5px solid #16a34a", borderRadius:8, background:"#f0fdf4",
              padding:"6px 16px", fontWeight:800, fontSize:18, color:"#15803d" }}>
              ₹{Math.round(processedOrder.amount_after_adjustment || Number(processedOrder.grand_total) - Number(processedOrder.adjustment_amount) || processedOrder.grand_total || 0)}
            </div>
            <button onClick={onClose} style={{ background:"none", border:"none",
              cursor:"pointer", color:"#9ca3af", padding:4, display:"flex", alignItems:"center" }}>
              <FaTimes size={18} />
            </button>
          </div>
        </div>

        {/* BODY */}
        <div style={{ flex:1, overflowY:"auto", padding:"12px 14px" }}>
          {processedOrder.order_items?.map((item, idx) => {
            const isBoarding      = item.item_type === "boarding";
            const isGroomingOrVet = item.item_type === "grooming" || item.item_type === "vet_clinic";
            // "locked" = cannot be edited or selected
            //const isLocked    = item.status !== "booked";
            //  const isLocked = mode === "scheduled"
            //   ? item.status !== "confirmed"   // in scheduled mode: only confirmed items are editable
            //   : item.status !== "booked";  
             const isPast = isPastDate(item);
              const isLocked = mode === "scheduled"
              ? item.is_queue === 1 
              : item.is_queue !== 1;  
         
            const isChecked   = !!checkedItems[idx];
            // fields are interactive only when booked + checkbox ticked
            const isEditable  = !isLocked && isChecked;

            const isFetchingRoom = !!fetchingRooms[idx];
            const isFetchingA    = !!fetchingAppt[idx];

            // room type changed from original?
            const roomTypeChanged = isBoarding && selectedRoomTypeId[idx]
              && selectedRoomTypeId[idx] !== origRoomTypeRef.current[idx];

            // current room type label
            const currentRoomTypeName =
              (roomTypesData[idx]||[]).find(rt => rt._id === selectedRoomTypeId[idx])?.room_name
              || item.room_name || "—";

            // current room number label
            const currentRoomNumber =
            (roomsData[idx]||[]).find(r => r._id === selectedRoomId[idx])?.room_number
            || item.room_number   // direct fallback from order data
            || "";
                      // current staff name
                      const currentStaffName =
            employees.find(e => (e._id||e.id) === selectedStaff[idx])?.name
            || apptDetail[idx]?.employee_name
            || item.employee_name   // direct fallback from order data (confirmed grooming items have this)
            || "—";
            const headerMeta = isBoarding ? (
              <>
                <span style={{ display:"flex", alignItems:"center", gap:3, fontSize:11.5, color:"#6b7280" }}>
                  <FaCalendarAlt size={11}/> In
                  <span style={{ color:"#2563eb", fontWeight:600 }}>{item.displayStartDate}</span>
                </span>
                <span style={{ display:"flex", alignItems:"center", gap:3, fontSize:11.5, color:"#6b7280" }}>
                  Out
                  <span style={{ color:"#2563eb", fontWeight:600 }}>{item.displayEndDate}</span>
                </span>
                {isPast && (
                  <span style={{ display:"flex", alignItems:"center", gap:3, fontSize:11, fontWeight:700,
                    color:"#b45309", background:"#fffbeb", border:"1px solid #fde68a",
                    padding:"2px 7px", borderRadius:20 }}>
                    ⚠ Past date
                  </span>
                )}
              </>
            ) : (
              <>
                <span style={{ display:"flex", alignItems:"center", gap:3, fontSize:11.5, color:"#6b7280" }}>
                  <FaCalendarAlt size={11}/>
                  <span style={{ color:"#2563eb", fontWeight:600 }}>{item.displayStartDate}</span>
                </span>
                {(item.start_time || item.time_range)&& (
                  <span style={{ fontSize:11.5, color:"#111213" }}>{item.start_time || item.time_range}</span>
                )}
                {isPast && (
                  <span style={{ display:"flex", alignItems:"center", gap:3, fontSize:11, fontWeight:700,
                    color:"#b45309", background:"#fffbeb", border:"1px solid #fde68a",
                    padding:"2px 7px", borderRadius:20 }}>
                    ⚠ Past date
                  </span>
                )}
              </>
            );

            const sectionTitle = item.service_type_name ||
              (isBoarding?"Kennel Boarding":item.item_type==="grooming"?"Grooming Salon":"Vet Clinic");

           // const slots = timeSlots[idx] || generateDefaultTimeSlots();
            const slots = (timeSlots[idx]?.length > 0)
              ? timeSlots[idx]
              : (timeSlots[idx]?.length === 0 ? [] : generateDefaultTimeSlots());

            return (
              <ServiceSection key={item.ref_id||idx}
                title={sectionTitle} headerMeta={headerMeta} isLocked={isLocked}
                initialOpen={
                    mode === "scheduled"
                      ? item.is_queue !== 1
                      : item.is_queue === 1
                  }
                //statusBadge={<StatusBadge status={item.status} />}
                statusBadge={<StatusBadge status={item.status} isQueue={item.is_queue} />}
                checkboxEl={
                  // <ItemCheckbox status={item.status} checked={isChecked}
                  //   onChange={() => !isLocked && toggleChecked(idx)} />
                 //<ItemCheckbox status={item.status} checked={isChecked} mode={mode}
                 <ItemCheckbox isQueue={item.is_queue} checked={isChecked} mode={mode}
                 onChange={() => !isLocked && toggleChecked(idx)} />
                }>

                {/* service name + price */}
                <div style={{ display:"flex", justifyContent:"space-between",
                  alignItems:"center", marginBottom:6 }}>
                  <span style={{ fontWeight:700, fontSize:14, color:isLocked?"#6b7280":"#111827" }}>
                    {item.service_name}{getFormattedDuration(item)?` (${getFormattedDuration(item)})`:""}
                  </span>
                  {/* <span style={{ fontWeight:700, fontSize:14, color:isLocked?"#9ca3af":"#111827" }}>
                    ₹{Math.round(item.final_total||item.total_price||0)}
                  </span> */}
                </div>

                {/* pet */}
                <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:12 }}>
                  <FaPaw size={14} color={isLocked?"#d1d5db":"#f97316"} />
                  <span style={{ fontSize:13, color:isLocked?"#9ca3af":"#374151" }}>
                    <strong>{item.pet_name}</strong>
                    {item.pet_type && <span style={{ color:"#5d5e61" }}> ({item.pet_type})</span>}
                    {item.pet_size  && ` • ${item.pet_size}`}
                    {item.pet_breed && ` • ${item.pet_breed}`}
                  
                  </span>
                   {item.weight_kg && (
                    <span style={{ 
                      fontSize:12, 
                      color:"#6b7280",
                      background:"#f3f4f6",
                      padding:"2px 8px",
                      borderRadius:12,
                      display:"inline-flex",
                      alignItems:"center",
                      gap:4
                    }}>
                      Weight : {item.weight_kg} kg
                    </span>
                  )}
                  {item.pet_tags?.map((tag, i) => {
                    const isAlert = ["Allergic","Aggressive","Sick","Injured","Anxious"].includes(tag);
                    return (
                      <span key={i} style={{
                        display:"inline-flex", alignItems:"center", gap:3,
                        padding:"1px 7px", borderRadius:20, fontSize:11, fontWeight:700,
                        background: isAlert ? "#fef2f2" : "#eff6ff",
                        color:      isAlert ? "#b91c1c" : "#1d4ed8",
                        border:     `1px solid ${isAlert ? "#fca5a5" : "#bfdbfe"}`,
                      }}>
                        {isAlert ? "⚠️" : "🏷️"} {tag}
                      </span>
                    );
                  })}
                </div>

                 {/* Vaccinations */}
                {item.vaccinations?.length > 0 && (
                  <div style={{ display:"flex", alignItems:"baseline", gap:6, flexWrap:"wrap", marginBottom:6 }}>
                    <span style={{ fontSize:12, color:"#111827", fontWeight:700, textTransform:"uppercase",
                      letterSpacing:"0.05em", flexShrink:0 }}>
                      Vaccines:
                    </span>
                    <span style={{ fontSize:12, color:"#111827", fontWeight:500 }}>
                      {item.vaccinations.join(", ")}
                    </span>
                  </div>
                )}
                 {/* Rabies vaccination warning */}
                {item.pet_name && isVaccinationRequiredForService(item) && !hasRabiesVaccination(item) && (
                  <div style={{
                    display: "inline-flex", alignItems:"center", alignSelf:"flex-start",gap:6,
                    marginBottom:6, padding:"4px 8px", borderRadius:6,
                    background:"#fef2f2", border:"1px solid #fca5a5",
                  }}>
                    <span style={{ fontSize:11 }}>⚠️</span>
                    <span style={{ fontSize:11, color:"#b91c1c", fontWeight:500 }}>
                      Rabies vaccination missing
                    </span>
                  </div>
                )}
                
               {/* Medical conditions */}
                {item.medical_condition?.length > 0 && (
                  <div style={{ display:"flex", alignItems:"baseline", gap:6, flexWrap:"wrap", marginBottom:6 }}>
                    <span style={{ fontSize:12, color:"#111827", fontWeight:700, textTransform:"uppercase",
                      letterSpacing:"0.05em", flexShrink:0 }}>
                      Medical:
                    </span>
                    <span style={{ fontSize:12, color:"#111827", fontWeight:500 }}>
                      {item.medical_condition.map(mc => mc.condition).join(", ")}
                    </span>
                  </div>
                )}

                {/* booking notes */}
                {item.notes && (
                  <NotesRow notes={item.notes} />
                )}

                <OrderFormsSection
                  orderId={processedOrder._id || processedOrder.order_id || orderId}
                  item={item}
                  clientPhone={processedOrder?.displayClientPhone || processedOrder?.client_phone || ""}
                  onMandatoryStatusChange={handleMandatoryStatusChange}
                  onFormIdsChange={handleFormIdsChange}
                  isBypassed={!!formBypassMap[getItemKey(item)]}
                  onBypassChange={handleFormBypassChange}
                />

                {/* ── BOARDING fields ── */}
                  {isBoarding && (
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>

                      {/* Room Type — always read-only, comes from order data */}
                      <div>
                        {fieldLabel("Room Type")}
                        {readOnlyBox(item.room_name || currentRoomTypeName)}
                      </div>

                      {/* Room Number — dropdown for booked, read-only for confirmed */}
                      <div>
                        {fieldLabel(
                          
                          isFetchingRoom ? "Checking availability…"
                          : roomMsg[idx] ? roomMsg[idx]
                          : "Room Number"
                        )}
                        {/* {isLocked ? (
                          readOnlyBox(currentRoomNumber) */}
                       {isLocked ? (
                        readOnlyBox(
                          currentRoomNumber ||
                          item.room_number ||
                         // (item.status === "booked" ? "Not assigned yet" : "")
                         (item.is_queue === 1 ? "Not assigned yet" : "")

                        )
                        ) : (
                          <>
                          <select
                            value={selectedRoomId[idx] || ""}
                           // onChange={e => setSelectedRoomId(p => ({ ...p, [idx]: e.target.value }))}
                            onChange={e => {
                            setSelectedRoomId(p => ({ ...p, [idx]: e.target.value }));
                            setFieldErrors(p => { const n={...p}; delete n[`room_${idx}`]; return n; });
                            }}
                          // disabled={isFetchingRoom || !roomsData[idx]?.length}
                           // style={dropdownStyle(!!selectedRoomId[idx], isFetchingRoom || !roomsData[idx]?.length)}>
                            disabled={!isEditable || isFetchingRoom || !roomsData[idx]?.length}
                           style={dropdownStyle(!!selectedRoomId[idx], !isEditable || isFetchingRoom || !roomsData[idx]?.length)}>
                           {isFetchingRoom ? (
                              <option>Checking availability…</option>
                            ) : !roomsData[idx]?.length ? (
                              <option value="">No rooms available</option>
                            ) : (
                              <>
                                <option value="">Select room no.</option>
                                {roomsData[idx].map(rm => (
                                  <option key={rm._id} value={rm._id}>{rm.room_number}</option>
                                ))}
                              </>
                            )}
                          </select>
                            {fieldError(fieldErrors[`room_${idx}`])}
                          </>
                        )}
                      </div>
                    </div>
                  )}

                {/* ── GROOMING / VET fields ── */}
                {isGroomingOrVet && (
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
                  {/* Time */}
                    <div>
                      {fieldLabel(" Time ")}
                      {isLocked ? (
                        readOnlyBox(selectedTime[idx] || apptDetail[idx]?.start_time || "")
                       ) : timeSlots[idx]?.length === 0 ? (
                        <div style={{ border:"1px solid #fca5a5", borderRadius:8, padding:"6px 10px",
                          fontSize:12, color:"#b91c1c", background:"#fef2f2", fontWeight:500 }}>
                          ⚠ Closed on this day — no time slots available
                        </div>
                      ) : (
                        <>
                        <select
                          value={selectedTime[idx] || "Select Time"}
                          //onChange={e => setSelectedTime(p => ({ ...p, [idx]: e.target.value }))}
                          onChange={e => {
                          setSelectedTime(p => ({ ...p, [idx]: e.target.value }));
                          setFieldErrors(p => { const n={...p}; delete n[`time_${idx}`]; return n; });
                        }}
                          //disabled={isFetchingA}
                         //</> style={dropdownStyle(!!selectedTime[idx], isFetchingA)}>
                         disabled={!isEditable || isFetchingA}
                         style={dropdownStyle(!!selectedTime[idx], !isEditable || isFetchingA)}>
                         <option value="">Select time</option>
                          {slots.map((slot,i) => <option key={i} value={slot}>{slot}</option>)}
                        </select>
                         {fieldError(fieldErrors[`time_${idx}`])}
                        </>
                      )}
                    </div>

                  {/* Staff */}
                  <div>
                    {fieldLabel(isFetchingA ? "Loading…" : "Staff")}
                    {/* {isLocked ? (
                      readOnlyBox(currentStaffName) */}
                      {isLocked ? (
                      readOnlyBox(
                        currentStaffName !== "—" 
                          ? currentStaffName 
                          : item.employee_name || item.technician_name || 
                            //(item.status === "booked" ? "Not assigned yet" : "")
                           (item.is_queue === 1 ? "Not assigned yet" : "")
                          )
                    ) : (
                      <>
                        <div style={{ position: "relative" }}>
                          <StaffSelector
                            appointment={{
                              ...item,
                              technician_id: selectedStaff[idx] || item.technician_id || "",
                              start_date: item.start_date,
                              start_time: selectedTime[idx] || "",
                              duration: item.duration,
                              service_category_type_id: item.service_category_type_id,
                              ref_id: item.ref_id,
                            }}
                            mode="update"
                            employees={employees}
                            index={idx}
                            // handleAppointmentFieldChange={(index, field, value) => {
                                            //   if (field === "technician_id") {
                                            //     setSelectedStaff(p => ({ ...p, [index]: value }));
                                            //   }
                                            // }}
                            handleAppointmentFieldChange={(index, field, value) => {
                              if (field === "technician_id") {
                                setSelectedStaff(p => ({ ...p, [index]: value }));
                                setFieldErrors(p => { const n = { ...p }; delete n[`staff_${index}`]; return n; });
                              }
                            }}
                          />
                          {!isEditable && (
                            <div style={{
                              position: "absolute", inset: 0,
                              cursor: "not-allowed", borderRadius: 8,
                              background: "rgba(243,244,246,0.6)",
                            }} />
                          )}
                        </div>
                        {fieldError(fieldErrors[`staff_${idx}`])}
                      </>
                    )}
                  </div>
                  </div>
                )}

               
              </ServiceSection>
            );
          })}

        </div>
        {/* FOOTER */}
      <div style={{
        padding:"12px 18px", borderTop:"1px solid #f3f4f6", background:"#fff",
        display:"flex", justifyContent:"flex-end", alignItems:"center",
        gap:10, flexShrink:0,
      }}>
        <ActionsDropdown
          disabled={isCancelling || isSaving || isScheduling}
          onSave={handleSave}
          onCancel={handleCancel}
          onModify={handleModifyAction}
          onPayNow={handlePayNow}
          isSaving={isSaving}
           onUnschedule={mode === "scheduled" ? handleUnschedule : null}
        />
          {mode === "scheduled" ? (
          <button
            onClick={handleCheckIn}
            disabled={isCheckingIn || isSaving || isUnscheduling || hasPendingMandatoryForSelected}
            style={{
              padding:"10px 32px", borderRadius:10, border:"none",
              cursor:(isCheckingIn || isSaving || hasPendingMandatoryForSelected) ? "not-allowed" : "pointer",
              background:(isCheckingIn || isSaving || hasPendingMandatoryForSelected) ? "#9ca3af" : "#0891b2",
              color:"#fff", fontWeight:800, fontSize:15,
            }}
          >
            {isCheckingIn ? "Opening…" : "Proceed"}
          </button>
          ) : (
          <button
            onClick={handleSchedule}
            disabled={isScheduling || isSaving || isScheduleDisabled()}
            style={{
              padding: "10px 32px",
              borderRadius: 10,
              border: "none",
            cursor:
              isScheduling || isSaving || isScheduleDisabled()
                ? "not-allowed"
                : "pointer",
            background:
              isScheduling || isSaving || isScheduleDisabled()
                ? "#9ca3af"
                : "#16a34a",
              color: "#fff",
            fontWeight: 800,
            fontSize: 15,
          }}
        >
  {isScheduling ? "Scheduling…" : "Schedule"}
</button>
          )}
        </div>       
        </div>
        {showPaymentDrawer && (
          <div onMouseDown={(e) => e.stopPropagation()}>
            <OrderPaymentDrawer
              isOpen={showPaymentDrawer}
              onClose={() => setShowPaymentDrawer(false)}
              orderId={processedOrder.order_id || processedOrder._id || orderId}
              onPaymentSuccess={() => {
                setShowPaymentDrawer(false);
                refreshData?.();
              }}
            />
          </div>
        )}
      </>
    ,
    document.body
    );
  };

export default BookingOrderPopup;